import {
  API_DELETE_SEARCH_HISTORY,
  API_GET_NOTIFICATION_LIST,
  API_GET_USER_SEARCH_LIST,
  API_POST_DEVICE_TOKEN_PARAMS,
  API_POST_USER_OBJECT,
  API_POST_USER_SEARCH_PAYLOAD,
} from './ApisRoutes';
import {deleteCMSRequest, getCMSRequest, postCMSRequest} from './CMSAPIs';

export const ServicePostPackageTag = params => {
  return new Promise((resolve, reject) => {
    postCMSRequest(API_POST_DEVICE_TOKEN_PARAMS, params)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};

export const ServicePostUserObject = params => {
  return new Promise((resolve, reject) => {
    postCMSRequest(API_POST_USER_OBJECT, params)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const ServicePostUserSearchPayload = params => {
  return new Promise((resolve, reject) => {
    postCMSRequest(API_POST_USER_SEARCH_PAYLOAD, params)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const ServiceGetUserSearchListing = guid => {
  return new Promise((resolve, reject) => {
    getCMSRequest(`${API_GET_USER_SEARCH_LIST}${guid}&per_page=3&page=1`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const ServiceGetNotificationsListing = params => {
  return new Promise((resolve, reject) => {
    const END_POINT = `${API_GET_NOTIFICATION_LIST}?player_id=${params?.playerId}&per_page=${params?.perPage}&page=${params?.page}`;
    getCMSRequest(END_POINT)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const ServiceDeleteNotificationsListing = data => {
  return new Promise((resolve, reject) => {
    deleteCMSRequest(API_GET_NOTIFICATION_LIST, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const ServiceDeleteSearchHistoryListing = data => {
  return new Promise((resolve, reject) => {
    deleteCMSRequest(API_DELETE_SEARCH_HISTORY, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};
